module.exports = __webpack_public_path__ + "static/media/battery-quarter.98fdf915.svg";